module.exports = __webpack_public_path__ + "static/media/Gorum.eb71be56.md";